// extracted by mini-css-extract-plugin
export var falconContainer = "_v6-2";
export var offerCenter = "_v6-0";
export var roktContainer = "_v6-1";